// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconShareLinkedin: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
            <path
                d="M174,1 L161.996875,1 C161.446875,1 161,1.453125 161,2.00937462 L161,13.9906254 C161,14.546875 161.446875,15 161.996875,15 L174,15 C174.55,15 175,14.546875 175,13.9906254 L175,2.00937462 C175,1.453125 174.55,1 174,1 Z M165.23125,13 L163.15625,13 L163.15625,6.3187499 L165.234375,6.3187499 L165.234375,13 L165.23125,13 Z M164.19375,5.40625 C163.528125,5.40625 162.990625,4.86562538 162.990625,4.203125 C162.990625,3.54062462 163.528125,3 164.19375,3 C164.85625,3 165.396875,3.54062462 165.396875,4.203125 C165.396875,4.86874962 164.859375,5.40625 164.19375,5.40625 L164.19375,5.40625 Z M173.009375,13 L170.934375,13 L170.934375,9.75 C170.934375,8.97500038 170.91875,7.9781251 169.85625,7.9781251 C168.775,7.9781251 168.609375,8.82187462 168.609375,9.69375038 L168.609375,13 L166.534375,13 L166.534375,6.3187499 L168.525,6.3187499 L168.525,7.23124981 L168.553125,7.23124981 C168.83125,6.70624971 169.509375,6.15312481 170.51875,6.15312481 C172.61875,6.15312481 173.009375,7.5374999 173.009375,9.33749962 L173.009375,13 Z"
                transform="translate(-161 -1)"
            />
        </svg>
    );
};

export default React.memo(IconShareLinkedin);
